import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import VueRouter from 'vue-router'
import App from './App.vue'
import { store } from './store/store'
import { routes } from './routes'
import VModal from 'vue-js-modal'
import Vuelidate from 'vuelidate'
import VueTippy, { TippyComponent } from "vue-tippy";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { VueMaskDirective } from 'v-mask';
import VueTypedJs from 'vue-typed-js'
import Multiselect from 'vue-multiselect';
import { publicPath } from '../vue.config';
import VueAnalytics from 'vue-analytics';
import VuePictureSwipe from 'vue-picture-swipe';

const optionsProgressBar = {
	color: '#C00C30',
	failedColor: '#C00C30',
	thickness: '2px',
	transition: {
		speed: '0.2s',
		opacity: '0.6s',
		termination: 300
	},
	autoRevert: true,
	location: 'top',
	inverse: false
}

Vue.component('multiselect', Multiselect)
Vue.component('vue-picture-swipe', VuePictureSwipe)

Vue.use(VueProgressBar, optionsProgressBar);
Vue.use(VueRouter);
Vue.use(VModal);
Vue.use(Vuelidate);
Vue.use(VueTippy);
Vue.use(Toast);
Vue.use(VueTypedJs);
Vue.use(require('vue-cookies'));
Vue.$cookies.config('365d');

Vue.directive('click-afuera', {
    bind: function (el, binding, vnode) {
        window.event = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', window.event)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', window.event)
    },
});

Vue.directive('mask', VueMaskDirective);
Vue.component("tippy", TippyComponent);

export const router = new VueRouter({
	routes,
	mode: 'history',
	base: publicPath
});

if(process.env.VUE_APP_DEVTOOLS === '1'){
	Vue.config.devtools = true;
} else {
	Vue.config.devtools = false;
	Vue.config.debug = false;
	Vue.config.silent = true; 
}

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
	id: 'UA-104071209-2',
	router
});

const app = new Vue({
	el: '#app',
	store,
	router,
	render: h => h(App)
})

router.beforeEach((to, from, next) => {
	store.dispatch('cargando', true);
	window.scrollTo(0, 0);

	if (!store.getters.loggedIn && (to.matched.some(route => route.name === 'invitacion-palco') && to.matched.some(route => route.name === 'cortesia'))) {
		window.location.href = process.env.VUE_APP_URL_NACIONALUY;
	} else {
		next()
	}

	// if (to.matched.some(record => record.meta.requiresAuth)) {
	// 	if (!store.getters.loggedIn) {
	// 		next({
	// 			name: 'login'
	// 		})
	// 	} else {
	// 		next()
	// 	}
	// } else if (to.matched.some(record => record.meta.requiresVisitor)) {
	// 	if (store.getters.loggedIn) {
	// 		next({
	// 			name: 'home'
	// 		})
	// 	} else {
	// 		next()
	// 	}
	// } else {
	// 	next()
	// }
})

router.afterEach((to, from) => {
	store.dispatch('cargando', false);
})